import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import LandingPage from "./app/pages/LandingPage";
import QuestionnairePage from "./app/questionnaire/QuestionnairePage";
import TechTeamHub from "./app/pages/TechTeamHub";

import RequireAuth from "./app/components/RequireAuth";
import RequireAdmin from "./app/components/RequireAdmin";

import LoginPage from "./app/pages/LoginPage";
import AdminToolsPage from "./app/pages/AdminToolsPage";
import ChangePasswordPage from "./app/pages/ChangePasswordPage";

import OfflineBanner from "./app/components/OfflineBanner";


export default function App() {
  return (
    <>
      <OfflineBanner />

      <Routes>

        {/* Public route */}
        <Route
          path="/login"
          element={<LoginPage />}
        />


        {/* Authenticated routes */}
        <Route
          path="/"
          element={
            <RequireAuth>
              <LandingPage />
            </RequireAuth>
          }
        />

        <Route
          path="/questionnaire/:id"
          element={
            <RequireAuth>
              <QuestionnairePage />
            </RequireAuth>
          }
        />

        <Route
          path="/change-password"
          element={
            <RequireAuth>
              <ChangePasswordPage />
            </RequireAuth>
          }
        />

        <Route
          path="/tech-team"
          element={
            <RequireAuth>
              <TechTeamHub />
            </RequireAuth>
          }
        />


        {/* Admin-only route */}
        <Route
          path="/admin-tools"
          element={
            <RequireAuth>
              <RequireAdmin>
                <AdminToolsPage />
              </RequireAdmin>
            </RequireAuth>
          }
        />


        {/* Fallback */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />

      </Routes>
    </>
  );
}